enum ProjectFolderType {
  System = 1,
  Custom = 2,
  LinkedEntity = 3
}

export default ProjectFolderType;
